import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { BILLING_PRODUCT } from '../constants';
import ConfirmCancelModal from './_ConfirmCancelModal';
import { tooltipShow } from '../../../../actions/tooltipActions';
import { CANCEL_SUBSCRIPTION_MODAL, RENEW_SUBSCRIPTION_MODAL } from '../../../../constants/modals';
import CheckIfAnyData from '../../../shared/CheckIfAnyData';
import Spinner from '../../../shared/_Spinner';

class SubscriptionTrialDetails extends React.Component {
    _handleTooltipShow = (id) => () => {
      const { showTooltip } = this.props;

      showTooltip(id);
    };

    render() {
      const { name, subscription, loading, trial } = this.props;
      const isCancelled = subscription.get('cancelledAt');
      const subscriptionSize = subscription ? subscription.size : 0;

      return (
        <Spinner  enabled={ loading }>
          <CheckIfAnyData dataSize={ subscriptionSize }>
            <div className={ 'subscription-settings__header' }>{BILLING_PRODUCT}</div>
            <div className={ 'subscription-settings__container' }>
              <div>
                <dl>
                  <dt>Trial to:</dt>
                  <dd>{name}</dd>
                  { isCancelled ?
                    <React.Fragment>
                      <dt>Cancelled date:</dt>
                      <dd>{subscription.get('cancelledAt')}</dd>
                      <dt>Trial until:</dt>
                      <dd>{trial}</dd>
                    </React.Fragment> :
                    <React.Fragment>
                      <dt>First billing date:</dt>
                      <dd>{subscription.get('activeUntil')}</dd>
                    </React.Fragment>
                  }
                </dl>
              </div>
              <div>
                <div className={ 'subscription-settings__item' }>
                  { isCancelled ?
                    <div className={ 'subscription-settings__item-wrapper' } onClick={ this._handleTooltipShow(RENEW_SUBSCRIPTION_MODAL) }>
                      <i aria-hidden='true' className={ 'fa fa-play-circle subscription-settings__item--icon' } />
                      <div>Renew subscription</div>
                    </div> :
                    <div className={ 'subscription-settings__item-wrapper' } onClick={ this._handleTooltipShow(CANCEL_SUBSCRIPTION_MODAL) }>
                      <i aria-hidden='true' className={ 'fa fa-ban subscription-settings__item--icon' } />
                      <div>Cancel subscription</div>
                    </div>}
                </div>
              </div>
            </div>
            <ConfirmCancelModal id={ CANCEL_SUBSCRIPTION_MODAL } type={ 'cancel' } />
            <ConfirmCancelModal id={ RENEW_SUBSCRIPTION_MODAL } type={ 'renew' } />
          </CheckIfAnyData>
        </Spinner>
      );
    }
}

SubscriptionTrialDetails.propTypes = {
  loading: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  showTooltip: PropTypes.func.isRequired,
  subscription: PropTypes.instanceOf(Immutable.Map).isRequired,
  trial: PropTypes.string
};

const mapStateToProps = (state) => {
  return {
    subscription: state.getIn(['paymentDetails', 'data', 'subscription'], Immutable.Map()),
    loading: state.getIn(['paymentDetails', 'loading']),
    name: state.getIn(['paymentDetails', 'data', 'name'], ''),
    trial: state.getIn(['currentUser', 'data', 'trialEndsAt'])
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showTooltip: (id) => dispatch(tooltipShow({ id }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionTrialDetails);



// WEBPACK FOOTER //
// ./app/components/reps/settings/subscription/SubscriptionTrialDetails.jsx